var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-app',{staticStyle:{"background-color":"#212121"}},[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('router-view')],1),_c('gm-snackbar'),_c('gm-loader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }